import React from 'react'
import './App.css'
import Main from './components/main/main'
import NavBar from './components/navBar/navbar'
import Right from './components/right/right'
import Profile from './components/profile/Profile'
import MemeCompetion from './components/meme-competion/MemeCompetion'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { StylesProvider } from '@material-ui/core'

const Home = () => {
  return (
    <div id="container">
      <div id="nav-box">
        <NavBar />
      </div>
      <Main />
      <Right />
    </div>
  )
}

const ProfileComponent = () => {
  return (
    <div id="container">
      <div id="nav-box">
        <NavBar />
      </div>
      <Profile />
      <Right />
    </div>
  )
}

const MemeCompetionComponent = () => {
  return (
    <div id="container">
      <div id="nav-box">
        <NavBar />
      </div>
      <MemeCompetion />
      <Right />
    </div>
  )
}

const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/follow-nfts">
          <ProfileComponent />
        </Route>
        <Route exact path="/competion">
          <MemeCompetionComponent />
        </Route>
      </Switch>
    </Router>
  )
}

export default App
